import React, { useState, useMemo } from "react";
import "./user-filter.scss";
import { SearchInputComponent } from "../../../../common/components";
import UserAddPopup from "../user-add-popup/user-add-popup";
import { Add } from "@mui/icons-material";
import { getPeopleForRoles } from "../../../../api/search-dashboard";
import { assignEltRoles } from "../../../../api/manage-permissions";
import { useSetLoading } from "../../../../common/hooks/appearance";

interface User {
  pk: number;
  firstName: string;
  employeeFullName: string;
  lastName: string;
  emailId: string;
  employeeId: number;
  users?: any;
}

const UserFilter: any = (props: any) => {
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);
  const [popupUsers, setPopupUsers] = useState<User[]>([]);
  const [popupLoading, setPopupLoading] = useState(false);

  const fetchUsersForPopup = async () => {
    setPopupLoading(true);
    try {
      const response = await getPeopleForRoles({
        searchText: "",
      });
      const usersWithNames = response.data.data?.map((user: any) => {
        const [firstName, ...lastName] = user.employeeFullName.split(" ");
        return {
          ...user,
          firstName,
          lastName: lastName.join(" "),
        };
      });
      setPopupUsers(usersWithNames);
    } catch (error) {
      console.error("Error fetching users for popup:", error);
    } finally {
      setPopupLoading(false);
    }
  };

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
  };
  const handleOpenAddPopup = () => {
    fetchUsersForPopup();
    setIsOpenAddPopup(true);
  };

  const addUserAsELT = async (employeeId: any) => {
    try {
      setPopupLoading(true);
      const res = await assignEltRoles({
        employeeId: employeeId?.filter(
          (userID: any) =>
            !props?.users?.find((user: any) => user?.pk === userID),
        ),
        roleId: 2,
      });
      console.log("Successfully assigned ELT role:", res);
    } catch (err) {
      console.error("Error assigning ELT role:", err);
    } finally {
      props.fetchUsers();
      setPopupLoading(false);
    }
  };
  const showLoading = useMemo(() => popupLoading, [popupLoading]);
  useSetLoading(showLoading);
  return (
    <>
      <div className="company-dashboard-user-filter">
        <SearchInputComponent
          placeholder="Search user"
          onSearch={props.onSearch}
          isReset={false}
          ref={null}
        />
        {props.activeTab === "elt" && (
          <button className="add-user-button" onClick={handleOpenAddPopup}>
            Add User <Add className="add-icon" fontSize="small" />
          </button>
        )}
      </div>
      {isOpenAddPopup ? (
        <UserAddPopup
          isOpen={isOpenAddPopup}
          onClose={handleCloseAddPopup}
          activeTab={props.activeTab}
          users={popupUsers}
          loading={popupLoading}
          onAddUsers={addUserAsELT}
          selectedUsersData={props?.users}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default UserFilter;
